<template>
    <div>
        <b-card :header="uLang('app.edit')" header-tag="h4" class="bg-default-card">
            <ApplicationActivityForm
                :id="id"
                :entityId="relationId"
            />
        </b-card>
    </div>
</template>

<script>
    import ApplicationActivityForm from '~/components/forms/application-activities/form'

    export default {
        name: 'edit',
        props: {
            id: {
                required: true,
            },
            relationId: {
                required: true,
            },
        },
        components: {
            'ApplicationActivityForm': ApplicationActivityForm,
        },
        created() {
            this.retrieveApplicationActivity();
        },
        methods: {
            async retrieveApplicationActivity() {
                let { data } = await window.axios.get(route('relations.application-activities.show', { id: this.id }));
                this.relation = data;
            },
        },
    }
</script>
